import {FC, PropsWithChildren} from "react";
import "./ActionButtons.scss";

export const ActionButtons: FC<PropsWithChildren> = ({children}) => {
  return <div className={"action-buttons"}>{children}</div>;
};
